import set from 'lodash.set';

/**
 * @description Разобрать пары ключ-значение с точечной нотацией в объект.
 * @param {[string, any][]} pairs Пары.
 * @returns {any}
 */
const parseFieldPairsToNestedObject = (pairs) => pairs
  .reduce((acc, [key, value]) => set(acc, key, value), {});

/**
 * @description Собрать значения именованных полей с элемента формы.
 * @param {HTMLFormElement} formElement Элемент формы.
 * @returns {any}
 */
export const collectNamedFieldsByElement = (formElement) => {
  const formData = new FormData(formElement);
  const pairs = Object.entries(Object.fromEntries(formData));
  return parseFieldPairsToNestedObject(pairs);
};

/**
 * @description Примесь формы.
 */
export default {
  methods: {
    collectNamedFieldsByElement,
  },
};
